// @flow
import styled from "styled-components";
const DefaultContainer = styled.div`
  border-left: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
  border-top: 1px solid #eeeeee;
  background-color: white;
  border-radius: 10px;
`;

const DefaultPaddedContainer = styled(DefaultContainer)`
  padding: 20px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.12) !important;
`;

const DefaultPaddedContainerNoShadow = styled(DefaultContainer)`
  padding: 20px;
`;

const MinimalContainerBase = styled.div`
  border-left: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
  border-top: 1px solid #eeeeee;
  background-color: white;
  border-radius: 0px;
`;

const MinimalContainer = styled(MinimalContainerBase)`
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12) !important;
`;

const MinimalContainerPadding = styled(MinimalContainerBase)`
  padding: 0px;
  background-color: rgb(0, 0, 0, 0);
  border: 0px;
`;

export {
  MinimalContainer,
  DefaultContainer,
  DefaultPaddedContainer,
  DefaultPaddedContainerNoShadow,
  MinimalContainerPadding
};
